import { render, staticRenderFns } from "./updateErrLog.vue?vue&type=template&id=24ec6df1"
import script from "./updateErrLog.vue?vue&type=script&lang=js"
export * from "./updateErrLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports